import { VNTENDERS_SET_REOPENED_TAB_PAYMENTS } from './ActionTypes'

/**
 * Action creator for setting reopened tab payments
 * This action should be used with a dispatch to update the state
 *
 * @param {Object} payload contains an orderUuid and an array of payments
 * @returns {Object}
 */
export const setReopenedTabPaymentsAction = (payload) => ({
  type: VNTENDERS_SET_REOPENED_TAB_PAYMENTS,
  payload,
})

/**
 * Set Tab Name Required
 * This will be read by CartSidebar and CartModal components to display "Tab Name" prompt
 *
 * @param {Object} payload contains an orderUuid and an array of payments
 * @returns
 */
export function setReopenedTabPayments(payload) {
  return (dispatch) => {
    dispatch(setReopenedTabPaymentsAction(payload))
  }
}
